export const palette = {
  primary: {
    main: '#00afd3',
    contrastText: '#FFF',
  },
  secondary: {
    main: '#131C3E',
    contrastText: '#FFF',
  },
  info: {
    main: '#32BEE1',
    contrastText: '#FFF',
  },
  warning: {
    main: '#F7B01E',
    contrastText: '#FFF',
  },
  error: {
    main: '#FF645F',
    contrastText: '#FFF',
  },
  success: {
    main: '#43CCAD',
    contrastText: '#222',
  },
};
